module.exports = __webpack_public_path__ + "static/chris_purple-1bc9424c2e03f94f47f78541ee04aba2.jpg";